var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('Sidebar'),_c('div',{staticClass:"px-5"},[_c('DashboardMainContent')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }